var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M836.3 989.9H187.7c-51.2 0-93.9-42.7-93.9-93.9V128c0.1-51.2 42.7-93.9 93.9-93.9h648.5c51.2 0 93.9 42.7 93.9 93.9v768c0 51.2-42.7 93.9-93.9 93.9zM187.7 85.3c-23.9 0-42.6 18.8-42.6 42.7v768c0 23.9 18.8 42.7 42.7 42.7h648.5c23.9 0 42.7-18.8 42.7-42.7V128c-0.1-23.9-18.8-42.7-42.7-42.7H187.7z",
    fill: "#3B086B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.7 658.8h-81.9c-13.7 0-25.6-11.9-25.6-25.6V426.7c0-13.7 11.9-25.6 25.6-25.6h81.9c13.7 0 25.6 11.9 25.6 25.6v204.8c0 15.4-11.9 27.3-25.6 27.3z m-56.3-51.2h30.7V454h-30.7v153.6zM553 658.8h-81.9c-13.7 0-25.6-11.9-25.6-25.6V334.5c0-13.7 11.9-25.6 25.6-25.6H553c13.7 0 25.6 11.9 25.6 25.6v298.7c0 13.7-11.9 25.6-25.6 25.6z m-56.3-51.2h30.7V360.1h-30.7v247.5z m223.5 51.2h-81.9c-13.7 0-25.6-11.9-25.6-25.6V257.7c0-13.7 11.9-25.6 25.6-25.6h81.9c13.7 0 25.6 11.9 25.6 25.6v375.5c0 13.7-11.9 25.6-25.6 25.6z m-56.3-51.2h30.7V283.3h-30.7v324.3zM720.2 791.9H303.8c-13.7 0-25.6-11.9-25.6-25.6s11.9-25.6 25.6-25.6h416.4c13.7 0 25.6 11.9 25.6 25.6s-11.9 25.6-25.6 25.6z",
    fill: "#3B086B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.80365573f07598aee70d7d040bcf581b.svg";
export { ForwardRef as ReactComponent };